import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { DaoService } from '../servicos/dao.service';

@Component({
  selector: 'app-cadastro-servidor',
  templateUrl: './cadastro-servidor.component.html',
  styleUrls: ['./cadastro-servidor.component.css']
})
export class CadastroServidorComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private dao: DaoService, private messageService: MessageService) { }

  formulario: FormGroup;
  imagemEscolhida:any;

  ngOnInit() {
    this.carregarFormularios();
    this.carregarPessoas();
  }

  editar(pes){
    this.formulario.controls.id.setValue(pes.id);
    this.formulario.controls.nome.setValue(pes.nome);
    this.formulario.controls.telefone.setValue(pes.telefone);
    this.formulario.controls.email.setValue(pes.email);

    this.imagemEscolhida = null;
  }


  carregarPessoas(){
    this.dao.submeter({},"obterTodasPessoas").then(res=>{
      this.pessoas = res;
    })
  }

  carregarFormularios() {

    this.formulario = this.formBuilder.group({
      id: [-1],
      nome:[null, Validators.required],
      email:[null,Validators.required],
      foto:[null],
      telefone:[null,Validators.required]
      
      
    });
  }

resu:any;
pessoas:any;
  salvar(){
    if(this.imagemEscolhida){
      this.formulario.controls.foto.setValue(JSON.stringify(this.imagemEscolhida.arquivo.split(",")[1]));
    }
      
    if(this.formulario.valid){
      let dados = JSON.parse(JSON.stringify(this.formulario.value));
      
      console.log("Os dados",dados);
      this.dao.submeter(dados,"salvarServidor").then(res=>{
        console.log(res);
        this.pessoas = res;
        this.formulario.reset();
        this.imagemEscolhida = null;
        this.formulario.controls.id.setValue(-1);
        this.dao.toast('s','Salvo');
      });
    }else{
      this.dao.toast('e','Preencha todos os campos para salvar o Servidor');
    }
  }

  mostrar:any;
  psel:any;
  funcao:any;
  grupo:any;
  lider:any;
  vinculos:any;
  origem:any;
  vinculo(pes){
    this.psel = pes;
   
    this.carregarVinculos();

  }

  excluirVinculo(vin){
    if(!this.psel)return;
    let dados = {id:vin.id, idPessoa:this.psel.id};
    this.dao.submeter(dados,"excluirVinculo").then(res=>{
      this.vinculos = res;
      this.dao.toast('s','Vinculo removido');
    });
  }

  adicionarVinculo(){
    if(!this.grupo || !this.funcao){
      this.dao.toast('e','Preencha todos os campos');
      return;
    }

    

    let ob = {
      id:this.idVinculo,
      idPessoa:this.psel.id,
      grupo:this.grupo,
      funcao:this.funcao,
      origem:this.origem,
      lider:this.lider?'sim':'nao'
    }

    this.dao.submeter(ob,"salvarVinculo").then(res=>{
      console.log("salvou",res);
      this.vinculos = res;
      this.funcao = null;
      this.grupo = null;
      this.origem = null;
      this.lider = undefined;
      this.dao.toast('s','Vinculo registrado');
    })
    console.log("Adicionando...")
  }

  carregarVinculos(){
    if(this.psel){
      let dados = {idPessoa:this.psel.id}
      this.dao.submeter(dados,"obterVinculos").then(res=>{
        this.vinculos = res;
        this.mostrar = true;
        this.idVinculo = -1;
      })
    }
  }

  cancelar(){
    this.funcao = null;
    this.origem = null;
    this.grupo = null;
    this.idVinculo = -1;
    this.lider = false;
  }

  idVinculo:any;
  editarVinculo(vin){
    this.funcao = vin.funcao;
    this.grupo = vin.grupo;
    this.origem = vin.origem;
    this.lider = vin.lider=='sim'?true:false
    this.idVinculo = vin.id;
  }

  async enviarArquivo(){
    let dom = await document.getElementById('ifile');
    dom.click();
    console.log(dom);
  }

  async escolheuArquivo(ev){
     
    let reader = new FileReader();
    reader.readAsDataURL(ev.target.files[0]);
    reader.onload = (res:any)=>{
      
      // console.log("lido",res.target.result);
      let pedacos = res.target.result.split(";");
      let tipo = pedacos[0];
      console.log("TIPO É:",tipo);
      if(tipo.includes('png') || tipo.includes('jpeg') || tipo.includes('jpg')){
        // console.log("POSITIVO");
        let arquivo = pedacos[1];
        let pacote = {
          arquivo:arquivo,
          tipo:tipo,
          completo:res.target.result
        }
        this.imagemEscolhida = pacote;
        console.log("O arquivo",this.imagemEscolhida);
      }else{
        this.dao.toast('e',"Somente permitido arquivos de imagem (png,jpg ou jpeg)");
      }
     };
   
}

  enviarToast(cor, titulo, texto) {
    this.messageService.add({ severity: cor, summary: titulo, detail: texto });
  }

  verificaValidTouched(campo) {
    if(!this.formulario.get(campo))return false;    
    return !this.formulario.get(campo).valid && this.formulario.get(campo).touched;
  }

}
